<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(title) }}</h2>

    <form [formGroup]="inputForm" class="input-form">
      @for (input of inputBoxes; track input) {
        @if (input.label !== "date") {
          <mat-form-field appearance="fill">
            <mat-label>{{ labelService.getLabel(input.label) }}</mat-label>
            <input
              matInput
              [formControlName]="input.label"
              [matAutocomplete]="auto"
              type="text"
              (input)="getSuggestions(input)"
            />
            <mat-autocomplete #auto="matAutocomplete">
              @for (suggestion of suggestions; track suggestion) {
                <mat-option
                  [value]="suggestion"
                  (click)="selectDescription(suggestion)"
                >
                  {{ suggestion }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        }
        @if (input.label === "date") {
          <mat-form-field appearance="fill">
            <mat-label>{{ labelService.getLabel(input.label) }}</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [formControlName]="input.label"
              appDateInput
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }
      }
    </form>

    <div class="panel-buttons">
      <button class="button-white" mat-stroked-button (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        class="button-white"
        mat-stroked-button
        (click)="onConfirm()"
        [disabled]="inputForm.invalid || isBtnClicked"
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
  </div>
</div>
